module.exports = __webpack_public_path__ + "static/media/3.09d40db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/existLogos/3.jpg
// module id = 979
// module chunks = 4